import React, {useEffect} from "react";
import SectionView from "../../../Common/Views/SectionView";
import Employee from "../../../Common/Models/Employee";
import EmployeeListItem from "../../../Common/Views/ListItems/EmployeeListItem";
import useFavorites from "../../../Common/Context/Consumers/useFavorites";
import ItemType from "../../../Common/Models/ItemType";
import toggleFavorite from "../../../Common/Helper/toggleFavorite";
import {useAuthState} from "react-firebase-hooks/auth";
import Firebase from "firebase";
import triggerHaptics from "../../../Common/Helper/triggerHaptics";

interface InstructorSectionProps {
    employee: Employee;
    onClick: (employee: Employee) => void;
}

const InstructorSection = (props: InstructorSectionProps) => {
    const {
        employee,
        onClick,
    } = props;

    const favorites: any = useFavorites();
    const [user] = useAuthState(Firebase.auth());


    const onClickFavorite = (itemID: string, itemType: ItemType) => {
        toggleFavorite(itemID,itemType,favorites, user.uid);
        triggerHaptics()
    };

    return (
        <SectionView title={"Instructor"}>
           <EmployeeListItem
               item={employee}
               displayFavorite={true}
               onClick={onClick}
               isFavorite={!!(favorites && favorites[ItemType.Employee] && favorites[ItemType.Employee][employee.id])}
               onClickFavorite={onClickFavorite}
               />
        </SectionView>
    );
};

export default InstructorSection;
